import { memo, forwardRef, createElement } from 'react';
import { useTheme } from '@vebox/etui-system';
import { Svg } from '@vebox/etui-system-elements';

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

function createSvg({
  name,
  viewBox,
  path,
  fill
}) {
  const Component = (props, ref) => {
    const theme = useTheme();
    let transform = '';
    if (props.rotate) {
      transform = `rotate(${props.rotate})`;
    }
    return /*#__PURE__*/createElement(Svg, _extends({
      viewBox: viewBox || '0 0 84 84',
      xmlSpace: "preserve",
      id: name,
      elRef: ref,
      userSelect: "none",
      width: "1em",
      height: "1em",
      display: "inline-block",
      fill: fill || 'currentColor',
      color: "inherit",
      stroke: "currentColor",
      overflow: "visible",
      flexShrink: "0",
      transform: transform,
      fontSize: theme ? theme.typography.pxToRem(24) : '24'
    }, props), path);
  };
  return /*#__PURE__*/memo(/*#__PURE__*/forwardRef(Component));
}

export { createSvg };
